module.exports = __webpack_public_path__ + "media/images/page/top/top_bg_05-a8234b1daa3022c034cb3efc11d7bd72.png";